import { Directive, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WorkspaceLifecycleService } from './workspace-lifecycle.service';

@Directive({
    selector: 'button[ashcorpReadonlyGate]',
    standalone: true,
})
export class ReadonlyGateDirective implements OnInit, OnDestroy {
    @Input() ashcorpReadonlyGate = true;

    @HostBinding('disabled') disabled = false;

    private _sub?: Subscription;

    constructor(private _lifecycle: WorkspaceLifecycleService) {}

    ngOnInit(): void {
        this._apply(this._lifecycle.isReadonly);
        this._sub = this._lifecycle.readonly$.subscribe((ro) => this._apply(ro));
    }

    ngOnDestroy(): void {
        this._sub?.unsubscribe();
    }

    private _apply(readonly: boolean): void {
        this.disabled = this.ashcorpReadonlyGate && readonly;
    }
}
